import {createContext, useContext, useState, ReactNode} from 'react';

export type ToastType = 'success' | 'error' | 'info' | 'warning';
export type Toast = {id: number; type: ToastType; message: string};

interface ToasterContextType {
  showToast: (toast: Omit<Toast, 'id'>) => void;
}

const ToasterContext = createContext<ToasterContextType | undefined>(undefined);

export function useToaster() {
  const ctx = useContext(ToasterContext);
  if (!ctx) throw new Error('useToaster must be used within ToasterProvider');
  return ctx;
}

export function ToasterProvider({children}: {children: ReactNode}) {
  const [toasts, setToasts] = useState<Toast[]>([]);

  function showToast(toast: Omit<Toast, 'id'>) {
    const id = Date.now() + Math.random();
    setToasts(ts => [...ts, {id, ...toast}]);
    setTimeout(() => setToasts(ts => ts.filter(t => t.id !== id)), 4000);
  }

  return (
    <ToasterContext.Provider value={{showToast}}>
      {children}
      <div className="toast toast-top toast-end z-50">
        {toasts.map(t => (
          <div key={t.id} className={`alert alert-${t.type} flex items-center`}>
            <span>{t.message}</span>
          </div>
        ))}
      </div>
    </ToasterContext.Provider>
  );
}
